import {EventEmitter} from 'eventemitter3'

export const columnDataTableEvent = new EventEmitter()

export const columnEventTypes = {
    COLUMN_VIEWED_CHANGE: 'COLUMN_VIEWED_CHANGE',
    COLUMN_VIEWED_RESTORE_DEFAULT: 'COLUMN_VIEWED_RESTORE_DEFAULT',
}

export function getColumnVisibilityChangeEventKey(tableType, eventType) {
    if (!tableType) {
        return ''
    }

    switch (eventType) {
        case columnEventTypes.COLUMN_VIEWED_CHANGE:
            return `COLUMN_VIEWED_CHANGE_${tableType}`

        case columnEventTypes.COLUMN_VIEWED_RESTORE_DEFAULT:
            return `COLUMN_VIEWED_RESTORE_DEFAULT_${tableType}`

        default:
            return ''
    }
}

export function onChangeColumnsViewedListener(
    tableType,
    eventType = columnEventTypes.COLUMN_VIEWED_CHANGE,
    newShownColumns = [],
    newHiddenColumns = [],
) {
    if (!tableType) {
        return
    }

    columnDataTableEvent.emit(
        `${getColumnVisibilityChangeEventKey(tableType, eventType)}`,
        newShownColumns,
        newHiddenColumns,
    )
}

export function removeChangeColumnsViewedListener(tableType, eventType) {
    if (!tableType) {
        return
    }

    columnDataTableEvent.removeListener(
        getColumnVisibilityChangeEventKey(tableType, eventType),
    )
}
